import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface ColorPalette {
  id: number;
  name: string;
  colors: string[];
}

export const COLOR_PALETTES: ColorPalette[] = [
  { id: 1, name: 'Sky Breeze', colors: ['#D6E4FF', '#ADC8FF', '#84A9FF', '#6690FF', '#3366FF'] },
  { id: 2, name: 'Ocean Depths', colors: ['#B2F5EA', '#81E6D9', '#4FD1C5', '#38B2AC', '#285E61'] },
  { id: 3, name: 'Sunset Glow', colors: ['#FFDAB9', '#FFB685', '#FF944D', '#FF6B1A', '#CC5200'] },
  { id: 4, name: 'Rose Quartz', colors: ['#FFD6E8', '#FFADD2', '#FF85C1', '#F759AB', '#C41D7F'] },
  { id: 5, name: 'Lavender Mist', colors: ['#EBD7FF', '#D3B4FF', '#B98AFF', '#9254DE', '#722ED1'] },
  { id: 6, name: 'Emerald Leaf', colors: ['#D1FAE5', '#A7F3D0', '#6EE7B7', '#34D399', '#059669'] },
  { id: 7, name: 'Golden Hour', colors: ['#FFF7CC', '#FFEC99', '#FFE066', '#FFD633', '#E6B800'] },
  { id: 8, name: 'Crimson Flame', colors: ['#FFD6D6', '#FFA3A3', '#FF7070', '#FF3D3D', '#CC0000'] },
  { id: 9, name: 'Mint Fresh', colors: ['#D5FDF4', '#A3FBE8', '#70F9DC', '#3DEFD0', '#1DBFA6'] },
  { id: 10, name: 'Stone Gray', colors: ['#F5F7FA', '#E4E7EB', '#CBD2D9', '#9AA5B1', '#7B8794'] },
];

@Component({
  selector: 'app-color-palette-selector',
  templateUrl: './color-palette-selector.component.html',
  styleUrls: ['./color-palette-selector.component.css'],
})
export class ColorPaletteSelectorComponent {

  COLOR_PALETTES = COLOR_PALETTES;
  @Input() selectedPalette: ColorPalette;
  @Output() select = new EventEmitter<ColorPalette>();


  onSelect(palette: ColorPalette) {

    this.selectedPalette = palette;
    this.select.emit(palette);
  }
}
